/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { AccountService } from './services/account.service';
export { AccountInformationService } from './services/account-information.service';
export { AggregatorsService } from './services/aggregators.service';
export { ApiTokenService } from './services/api-token.service';
export { AuditService } from './services/audit.service';
export { AuthenticatedMobileService } from './services/authenticated-mobile.service';
export { AutomaticResendsService } from './services/automatic-resends.service';
export { BankOnlineGatewaysService } from './services/bank-online-gateways.service';
export { BlackListsService } from './services/black-lists.service';
export { Bulk2ServicesService } from './services/bulk-2-services.service';
export { BulkServicesService } from './services/bulk-services.service';
export { CalendersService } from './services/calenders.service';
export { CampaignsService } from './services/campaigns.service';
export { CheckNumberClassResponsesService } from './services/check-number-class-responses.service';
export { ChequePaymentsService } from './services/cheque-payments.service';
export { ClaimsService } from './services/claims.service';
export { CompetitionParserService } from './services/competition-parser.service';
export { ContactCustomFieldsService } from './services/contact-custom-fields.service';
export { ContactsService } from './services/contacts.service';
export { CreditNotificationService } from './services/credit-notification.service';
export { CustomerClubDeviceNumbersService } from './services/customer-club-device-numbers.service';
export { CustomerClubDevicesService } from './services/customer-club-devices.service';
export { CustomerDomainConfigurationsService } from './services/customer-domain-configurations.service';
export { CustomerDomainsService } from './services/customer-domains.service';
export { CustomPlaceService } from './services/custom-place.service';
export { DiscountService } from './services/discount.service';
export { DocumentService } from './services/document.service';
export { DynamicTemplatesService } from './services/dynamic-templates.service';
export { EntitiesParametersService } from './services/entities-parameters.service';
export { EnumsService } from './services/enums.service';
export { ExcelService } from './services/excel.service';
export { FilterWordsService } from './services/filter-words.service';
export { FormBuilderFieldsService } from './services/form-builder-fields.service';
export { FormBuildersService } from './services/form-builders.service';
export { GroupPriceCategoriesService } from './services/group-price-categories.service';
export { GroupPriceDetailsService } from './services/group-price-details.service';
export { GroupPricesService } from './services/group-prices.service';
export { GroupPriceSocialMediaDetailsService } from './services/group-price-social-media-details.service';
export { GuildsService } from './services/guilds.service';
export { InboxesService } from './services/inboxes.service';
export { InboxGroupsService } from './services/inbox-groups.service';
export { InformationsService } from './services/informations.service';
export { KibanaDashboardsService } from './services/kibana-dashboards.service';
export { LandingPagesService } from './services/landing-pages.service';
export { MapService } from './services/map.service';
export { MapsPostalCodesService } from './services/maps-postal-codes.service';
export { MenusService } from './services/menus.service';
export { NotificationsService } from './services/notifications.service';
export { OccasionScheduledMessagesService } from './services/occasion-scheduled-messages.service';
export { OrganizationBlackListExceptionsService } from './services/organization-black-list-exceptions.service';
export { OrganizationCustomFieldsService } from './services/organization-custom-fields.service';
export { OrganizationsService } from './services/organizations.service';
export { OrganizationTransactionsService } from './services/organization-transactions.service';
export { OtpsService } from './services/otps.service';
export { OutboxMessageNumbersService } from './services/outbox-message-numbers.service';
export { OutBoxMessageResendHistoriesService } from './services/out-box-message-resend-histories.service';
export { OutBoxMessagesService } from './services/out-box-messages.service';
export { PackageOrganizationsService } from './services/package-organizations.service';
export { PackageSalesService } from './services/package-sales.service';
export { PaymentsService } from './services/payments.service';
export { PhonebookCustomFieldsService } from './services/phonebook-custom-fields.service';
export { PhonebookFileProgressesService } from './services/phonebook-file-progresses.service';
export { PhonebooksService } from './services/phonebooks.service';
export { PlansService } from './services/plans.service';
export { PrivateNumberBuyRequestService } from './services/private-number-buy-request.service';
export { PrivateNumberPriceService } from './services/private-number-price.service';
export { PrivateNumbersService } from './services/private-numbers.service';
export { PrivateNumberSendLimitService } from './services/private-number-send-limit.service';
export { PublicPlaceCategoriesService } from './services/public-place-categories.service';
export { PublicPlaceService } from './services/public-place.service';
export { RabbitStatisticsService } from './services/rabbit-statistics.service';
export { ReadyTemplatesService } from './services/ready-templates.service';
export { ReceiveKeywordsService } from './services/receive-keywords.service';
export { RedisService } from './services/redis.service';
export { RefundDeliveryStatusesService } from './services/refund-delivery-statuses.service';
export { ResellersService } from './services/resellers.service';
export { ResellerTargetService } from './services/reseller-target.service';
export { RolesService } from './services/roles.service';
export { ScheduledMessagesService } from './services/scheduled-messages.service';
export { SendLimitsService } from './services/send-limits.service';
export { SettingsService } from './services/settings.service';
export { ShortLinksService } from './services/short-links.service';
export { SmartSmsCampaignsService } from './services/smart-sms-campaigns.service';
export { SmartSmsClubsService } from './services/smart-sms-clubs.service';
export { SmartSmsService } from './services/smart-sms.service';
export { SmartSmsNumberClassesService } from './services/smart-sms-number-classes.service';
export { SmartSmsRecipientsService } from './services/smart-sms-recipients.service';
export { SmartSmsRequestsService } from './services/smart-sms-requests.service';
export { SmsSenderAgentsService } from './services/sms-sender-agents.service';
export { SmsTemplateGroupsService } from './services/sms-template-groups.service';
export { SmsTemplatesService } from './services/sms-templates.service';
export { SocialMediaApplicationsService } from './services/social-media-applications.service';
export { SocialNetworkMessageFilesService } from './services/social-network-message-files.service';
export { StatisticsService } from './services/statistics.service';
export { SuperAdminsService } from './services/super-admins.service';
export { SurveyParserService } from './services/survey-parser.service';
export { SystemSettingsService } from './services/system-settings.service';
export { TempService } from './services/temp.service';
export { TextParsersService } from './services/text-parsers.service';
export { UserDailyValueOfPurchaseAlertSettingService } from './services/user-daily-value-of-purchase-alert-setting.service';
export { UserSafeIPsService } from './services/user-safe-i-ps.service';
export { UsersService } from './services/users.service';
export { UserValueOfPurchasePointStrategiesService } from './services/user-value-of-purchase-point-strategies.service';
export { UserValueOfPurchasesService } from './services/user-value-of-purchases.service';
export { UserValueOfPurchasesPointsService } from './services/user-value-of-purchases-points.service';
export { UserValueOfPurchaseStrategiesService } from './services/user-value-of-purchase-strategies.service';
export { VoiceMessageGroupsService } from './services/voice-message-groups.service';
export { VoiceMessagesService } from './services/voice-messages.service';
export { WebhookService } from './services/webhook.service';
export { WhiteMessagesService } from './services/white-messages.service';
export { ZonePostalCodesService } from './services/zone-postal-codes.service';
export { ZonesService } from './services/zones.service';
export { CspReportService } from './services/csp-report.service';
export { Gen204Service } from './services/gen-204.service';
export { PrefetchProxyService } from './services/prefetch-proxy.service';
